








































import mixins from 'vue-typed-mixins';
import cloneDeep from 'lodash.clonedeep';
import { Location } from 'vue-router';
import SurveyGroupModal from '@/components/survey/management/SurveyGroupModal.vue';
import SurveyGroupForm from '@/components/survey/management/SurveyGroupForm.vue';
import { SurveyGroup } from '../../utils/SurveyUtils';
import SurveyUtils from '../../utils/SurveyUtils';
import deepEqual from 'deep-equal';
export default mixins().extend({
  components: {
    SurveyGroupForm,
    SurveyGroupModal,
  },

  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },

    tabs() {
      return [
        {
          text: this.$tc('app.label.detail', 2),
          location: { name: 'survey-group-edit-details' },
        },
        {
          text: this.$tc('model.dashboard.tile.label', 2),
          location: { name: 'survey-group-dashboard-tiles' },
        },
        {
          text: this.$tc('model.worksheet.label', 2),
          location: { name: 'survey-group-edit-worksheets' },
        },
      ];
    },

    tab(): undefined | number {
      return this.tabs?.findIndex(
        (tab: any) => this.$route.name === tab.location.name
      );
    },
  },

  data(): {
    pristine?: Partial<SurveyGroup>;
    group?: Partial<SurveyGroup>;
  } {
    return {
      pristine: undefined,
      group: undefined,
    };
  },

  async mounted() {
    this.$loading(true);
    try {
      if (this.id) {
        const resp = await Promise.all([
          SurveyUtils.api.surveyGroup.get(this.id),
        ]);
        this.group = {
          ...resp[0],
          dashboard: {
            canvas: {
              left: resp[0]?.dashboard?.canvas?.left || [],
              right: resp[0]?.dashboard?.canvas?.right || [],
            },
          },
        };
        this.pristine = cloneDeep(this.group);
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
    this.$loading(false);
  },

  methods: {
    async navigate(location: Location) {
      if (
        typeof location === 'string'
          ? this.$route.path !== location
          : this.$route.name !== location.name
      ) {
        let allowNavigation = !deepEqual(this.group, this.pristine)
          ? await this.$confirm(
              this.$i18n.t('validation.confirmation.navigation').toString()
            )
          : true;

        if (allowNavigation) {
          await this.$router.push(location);
          this.group = cloneDeep(this.pristine);
        }
      }
    },

    handlePristine(pristine: Partial<SurveyGroup>) {
      this.pristine = {
        ...this.pristine,
        ...cloneDeep(pristine),
      };
    },

    async submit() {
      let groupToSubmit = cloneDeep(this.group ? this.group : {});
      if( groupToSubmit.state == this.pristine?.state) {
        groupToSubmit.state = undefined;
        if (groupToSubmit) {
          await SurveyUtils.api.surveyGroup.update(groupToSubmit);
          this.pristine = cloneDeep(this.group);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.surveyGroup.label')],
            }),
          });
        }
      }
      else {
        if (groupToSubmit?.state == 'active') {
          await this.$confirm(
            this.$i18n
              .t('validation.confirmation.surveyGroup.activate', [
                this.group?.name,
              ])
              .toString(),
            async () => {
              if (groupToSubmit) {
                await SurveyUtils.api.surveyGroup.update(groupToSubmit);
                this.pristine = cloneDeep(this.group);
                this.$toast.push({
                  type: 'success',
                  text: this.$languageobj('validation.success.default', {
                    values: [this.$languageobj('model.surveyGroup.label')],
                  }),
                });
              }
            }
          );
        } else if (groupToSubmit?.state == 'inactive') {
          await this.$confirm(
            this.$i18n
              .t('validation.confirmation.surveyGroup.deactivate', [
                this.group?.name,
              ])
              .toString(),
            async () => {
              if (groupToSubmit) {
                await SurveyUtils.api.surveyGroup.update(groupToSubmit);
                this.pristine = cloneDeep(this.group);
                this.$toast.push({
                  type: 'success',
                  text: this.$languageobj('validation.success.default', {
                    values: [this.$languageobj('model.surveyGroup.label')],
                  }),
                });
              }
            }
          );
        } else if (groupToSubmit?.state == 'closed') {
          await this.$confirm(
            this.$i18n
              .t('validation.confirmation.surveyGroup.close', [this.group?.name])
              .toString(),
            async () => {
              if (groupToSubmit) {
                await SurveyUtils.api.surveyGroup.update(groupToSubmit);
                this.pristine = cloneDeep(this.group);
                this.$toast.push({
                  type: 'success',
                  text: this.$languageobj('validation.success.default', {
                    values: [this.$languageobj('model.surveyGroup.label')],
                  }),
                });
              }
            }
          );
        } else if (groupToSubmit?.state == 'archived') {
          (this.$refs.surveyGroupModal as any).open(this.group);
        }
      }
    },
  },
});
